import { render } from "./JustTransitionCarbonCollege.vue?vue&type=template&id=68e77830&ts=true"
import script from "./JustTransitionCarbonCollege.vue?vue&type=script&lang=ts"
export * from "./JustTransitionCarbonCollege.vue?vue&type=script&lang=ts"

import "./JustTransitionCarbonCollege.vue?vue&type=style&index=0&id=68e77830&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__